/**
 * FIN-12659 — adapts the role-shaped fraud alert transaction-history response
 * (GET /fraudAlerts/{alertId}/transactionHistory: items carry nested
 * sender/receiver objects) to the flat keys the shared TM_IAD column
 * renderers consume. Role semantics are stable by design: sender maps to the
 * party-side columns, receiver to the counterparty/opposite-side columns.
 * The nested objects are kept on the item for future role-shaped columns.
 */
export const flattenFraudTransaction = (item) => {
  const { sender = {}, receiver = {}, ...rest } = item;
  return {
    ...rest,
    partyKey: sender.key,
    accountId: sender.account,
    counterParty: receiver.key,
    counterpartyId: receiver.key,
    counterpartyKey: receiver.key,
    counterPartyName: receiver.name,
    counterpartyName: receiver.name,
    counterpartyNationality: receiver.nationality,
    counterpartyType: receiver.partyType,
    oppAccountNumber: receiver.account,
    // FIN-13606: receiver-side payer + amount keys. The FRAML grid columns were bound to
    // legacy keys (atmId / tellerId / localCurrencyEquivalent) the canonical response never
    // carries, so they rendered blank.
    oppPayerName: receiver.payerName,
    oppPayerService: receiver.payerService,
    oppAmountUsd: receiver.amountUsd,
    sender,
    receiver
  };
};

export const flattenFraudTransactionHistory = (data) => ({
  ...data,
  payload: (data?.payload || []).map(flattenFraudTransaction)
});
